module.exports = __webpack_public_path__ + "img/icon5.4c9ef6bf.png";